
import { Game } from "@/data/Game";
import AbstractVue from "@/views/AbstractVue";
import { gsap } from "gsap";
import { Options } from "vue-class-component";

@Options({
  props: ["displayGames"]
})
export default class Games extends AbstractVue {
  displayGames: Game[];

  selectGame(game: Game): void {
    this.parameters.game = game;
    if (game.getConfigs().length == 1) {
      this.$router.push("/gametesting");
    } else {
      this.$router.push("/configselect");
    }
  }

  beforeEnter(el: HTMLElement): void {
    el.style.opacity = "0";
    el.style.transform = "scale(0)";
  }

  enter(el: HTMLElement, done: () => void): void {
    gsap.to(el, {
      opacity: 1,
      scale: 1,
      duration: 1,
      onComplete: done,
      delay: 0.2 * +el.dataset.index,
    });
  }
}
